import React from 'react';

import { Card, CardContent, Grid } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    AutocompleteField,
    InputSearch,
    ManageCsvDropdown,
} from 'common/components';

const BulkOperationsCard = ({
    countryOptions,
    downloadFile,
    filterData,
    handleClickCountry,
    handleOnChangeSearch,
    isFetchingCountries,
}) => {
    const { t } = useTranslation();

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Grid
                    alignItems="end"
                    container
                    justifyContent="flex-end"
                    spacing={2}
                >
                    <Grid size="grow">
                        <InputSearch
                            placeholder={t('Search')}
                            onChange={handleOnChangeSearch}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid
                        size={{ lg: 3, md: 9, xs: 18 }}
                        sx={{ order: { xs: 3, md: 2 } }}
                    >
                        <AutocompleteField
                            disabled={isFetchingCountries}
                            label={
                                isEmpty(filterData?.countryName)
                                    ? t('All countries')
                                    : t('Country')
                            }
                            onChange={handleClickCountry}
                            options={countryOptions}
                            value={filterData?.countryName}
                        />
                    </Grid>

                    <Grid sx={{ order: { xs: 2, md: 3 }, textAlign: 'right' }}>
                        <ManageCsvDropdown
                            handleDownload={() => downloadFile(filterData)}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    countryOptions: PropTypes.array,
    downloadFile: PropTypes.func,
    filterData: PropTypes.object,
    handleClickCountry: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    isFetchingCountries: PropTypes.bool,
};

export default BulkOperationsCard;
